import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SpinnerProps {
  size?: number;
  className?: string;
  /** Quando fornecido, renderiza role="status" + aria-label (modo semântico). Sem label = decorativo. */
  label?: string;
}

export function Spinner({ size = 16, className, label }: SpinnerProps) {
  return (
    <Loader2
      className={cn('animate-spin text-primary', className)}
      style={{ width: size, height: size }}
      {...(label ? { role: 'status', 'aria-label': label } : {})}
    />
  );
}
